import type { FaireProductEntity } from "../../entity_types/product";

export const p_m8zu84yw5e: FaireProductEntity = {
  token: "p_m8zu84yw5e",
  type: "product",
  name: "Mahjong Shaped Ornament",
  brandToken: "b_cqs47snpii",
  brandName: "Happy Everything!",
  imageUrl:
    "https://cdn.faire.com/fastly/8cf04d69ded5279bd3fa2d741e8f26614bd9b6d3805fc350354bd9d06deadd66.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f7237c0a6b1cce412a0ce01cc2af293c3fbabfff722ec6bd0a2d25aaa8fce30a.jpeg",
  ],
  priceDollars: 12.45,
  description:
    "Let the love of your favorite game shine with our Mahjong Shaped Ornament. This handblown glass bauble is made up of intricately designed tiles and a vibrantly colored “mahjong” in block lettering. Display it front and center on your tree for all to see, or gift one to your mahjong besties. Giftable and oh-so-cute, this shaped ornament will be a happy addition to your tree.\n\n𝐏𝐫𝐨𝐝𝐮𝐜𝐭 𝐃𝐢𝐦𝐞𝐧𝐬𝐢𝐨𝐧𝐬:\n4inL x 3.75inW x 1inH",
  tags: [],
  msrpDollars: 27.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:52.039Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
